import { Search } from '@mui/icons-material'
import { Pagination } from '@mui/material'
import { useState } from 'react'
import { ITableProps } from '../../../../../shared/types'
import Select from '../../../../organisms/Select'

export default function Table({title,tableHeadData, tableBodyData, handleItemClick=()=>{}}:ITableProps) {

    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] =useState(5)
    
  return (
    <div
        className='w-full h-full text-secondary2 '
    >
        <div className="flex w-full justify-between items-center mb-4">
            <label className="bg-blue-500/20 py-2 px-4 rounded border border-blue-500/60">
                {title}
            </label>

            <div>
                <div className='flex justify-center items-center py-1 border-b border-b-gray-600'>
                    <Search fontSize="small" className='text-gray-600' />
                    <input 
                        placeholder='...search' 
                        className='bg-white/0 focus:outline-none'
                    />
                </div>
            </div>
        </div>
        
        <table className='w-full block '>

            <thead className='w-full block'>
                <tr className='py-6 w-full flex justify-center items-center text-left border-b-2 border-b-gray-600 text-ellipsis ' >
                    {
                        tableHeadData.map((headData, index)=>(
                            <th key={index} className='block flex-1 overflow-hidden'>
                                <p
                                    className='w-48 truncate overflow-hidden'
                                >
                                    {headData}
                                </p>
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody className='text-gray-400 block w-full'>
                {
                    tableBodyData.slice((currentPage-1)*itemsPerPage, itemsPerPage*currentPage).map((data, index)=>(

                        <tr 
                            className='cursor-pointer py-4 w-full flex justify-center items-center text-left border-b border-b-white/20 focus:outline-none'
                            onClick={()=>{
                                handleItemClick(data)
                            }}
                            key={index}
                            aria-label='button'
                            
                        >
                            <td className='flex-1'>
                            <p
                                    className='w-48 truncate overflow-hidden'
                                >
                                    {data.name}
                            </p>
                            </td>
                            <td className='flex-1'>{data.gross_revenue}</td>
                            <td className='flex-1'>{data.gross_profit}</td>
                            <td className='flex-1'>{data.items_in_stock}</td>
                            <td className='flex-1'>{data.cash_in_shop}</td>
                        </tr>
                        
                    ))
                } 
                
            </tbody>
            
        </table>

        <div className="mt-8 flex flex-row-reverse">

            <Pagination 
                shape='rounded'
                variant='outlined'
                count={Math.round(tableBodyData.length/itemsPerPage)}
                page={currentPage}
                color="secondary"
                onChange={(e, value)=>setCurrentPage(value)}
            />

            <div className="flex justify-center items-center">
                Items per page: &nbsp;
                <Select
                    data={[
                        {value:5, label: "Five"},
                        {value:10, label: "Ten"},
                        {value:15, label: "Fifteen"},
                    ]}
                    // title="Rows per page"
                    value={itemsPerPage}
                    onChange={(value)=>setItemsPerPage(parseInt(value))}
                />
            </div>

            
        </div>
        
    </div>
  )
}